@if (control$$()) {
    <mat-form-field
        [ngClass]="classHeight$$()"
        [class.show-hint]="hint$$() || hintLabel$$()"
        [class.show-error]="control$$().invalid && errorShow$$()"
        [appearance]="appearance$$()"
        [color]="color$$()"
        [floatLabel]="floatLabel$$()"
        [hideRequiredMarker]="hideRequiredMarker$$()"
        [hintLabel]="hintLabel$$()"
        [subscriptSizing]="subscriptSizing$$()">

        @if (label$$()) {
            <mat-label>{{label$$()}}:</mat-label>
        }
        <input matInput
            (keydown.esc)="emit_esc($event)"
            [attributes]="attributes$$()"
            [autofocus]="autofocus$$()"
            [errorStateMatcher]="errorStateMatcher$$()"
            [formControl]="control$$()"
            [id]="id$$()"
            [matAutocomplete]="auto"
            [matAutocompleteDisabled]="readonly$$()"
            [placeholder]="placeholder$$()"
            [readonly]="readonly$$()"
            [required]="required$$()"
            [tabindex]="tabIndex$$()"
        >
        @if (input_suffixIcon$$()) {
            <button mat-icon-button matSuffix type="button"
                (click)="emit_suffixClick($event)"
                [attr.aria-label]="input_suffixTooltip$$()"
                [disabled]="control$$().disabled"
                [matTooltip]="input_suffixTooltip$$() ?? ''"
            >
                <mat-icon>{{ input_suffixIcon$$() }}</mat-icon>
            </button>
        }
        <mat-autocomplete #auto
            (optionSelected)="emit_afterSelect()"
            [autoActiveFirstOption]="input_autoActiveFirstOption$$()"
            [panelWidth]="input_panelWidth$$()"
        >
            @for (item of filtered$$(); track trackValue(item)) {
                <mat-option
                    (onSelectionChange)="emit_optionSelected(item, $event.isUserInput)"
                    [value]="itemText(item)"
                >
                    @if (input_optionTemplate$$(); as template) {
                        <ng-container *ngTemplateOutlet="template; context: { $implicit: item }" />
                    } @else {
                        {{ itemText(item) }}
                    }
                </mat-option>
            }
        </mat-autocomplete>
        @if (!!hint$$()) {
            <mat-hint [align]="hintAlign$$()">{{hint$$()}}</mat-hint>
        }
        @if (control$$().invalid && errorShow$$()) {
            <mat-error>{{errorMessage_getFirst()}}</mat-error>
        }
    </mat-form-field>
}
